export const KICKSTARTER_MAILCHIMP_TAGS = ["LP Kickstarter"]
export const KICKSTARTER_MAILCHIMP_STATUS = "subscribed"
export const KICKSTARTER_PAGE_PATH = "/kickstarter-landing"
export const WORK_FROM_HOME_PAGE_PATH = "/work-from-home"
export const SLEEP_BETTER_PAGE_PATH = "/sleep-better"
